import { ref, computed } from 'vue'

// Permissions de l'utilisateur connecté
const userPermissions = ref(null)
const userRole = ref(null)

export function usePermissions() {
  // Charger les permissions depuis localStorage
  const loadPermissions = () => {
    const user = JSON.parse(localStorage.getItem('user') || '{}')
    userRole.value = user.role || null
    userPermissions.value = user.permissions || null

    console.log('🔐 Permissions chargées:', userRole.value, userPermissions.value)
  }

  // Vérifier si l'utilisateur est admin (support super_admin pour compatibilité)
  const isAdmin = computed(() => userRole.value === 'admin' || userRole.value === 'super_admin')

  // Vérifier si l'utilisateur a une permission spécifique
  const hasPermission = (permission) => {
    // Les admins et super_admins ont toutes les permissions
    if (isAdmin.value) return true

    // Les collaborateurs doivent avoir la permission spécifique
    if (userRole.value === 'collaborateur') {
      return userPermissions.value && userPermissions.value[permission] === true
    }

    // Par défaut, refuser l'accès
    return false
  }

  // Vérifier plusieurs permissions (au moins une requise)
  const hasAnyPermission = (permissions) => {
    if (isAdmin.value) return true
    return permissions.some(perm => hasPermission(perm))
  }

  // Initialiser au chargement
  if (!userPermissions.value) {
    loadPermissions()
  }

  return {
    userPermissions,
    userRole,
    isAdmin,
    hasPermission,
    hasAnyPermission,
    loadPermissions
  }
}
